import { useEffect, useState } from "react";
import { MdAdd, MdDelete, MdEdit, MdNotifications, MdPriorityHigh, MdWarning } from "react-icons/md";
import Card from "components/card";
import { api } from "api";

const PRIORITY_LABELS: Record<string, string> = { normal: "Normal", important: "Onemli", urgent: "Acil" };
const PRIORITY_STYLES: Record<string, string> = {
  normal: "bg-blue-100 text-blue-700", important: "bg-orange-100 text-orange-700", urgent: "bg-red-100 text-red-700",
};
const PRIORITY_ICONS: Record<string, any> = {
  normal: <MdNotifications className="h-4 w-4" />, important: <MdWarning className="h-4 w-4" />, urgent: <MdPriorityHigh className="h-4 w-4" />,
};

const Duyurular = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [form, setForm] = useState({ title: "", content: "", priority: "normal", publish_date: "", expire_date: "", send_push: true });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    api.getDuyurular().then(setItems).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  const openCreate = () => {
    setEditId(null);
    setForm({ title: "", content: "", priority: "normal", publish_date: new Date().toISOString().split("T")[0], expire_date: "", send_push: true });
    setError("");
    setShowForm(true);
  };

  const openEdit = (item: any) => {
    setEditId(item.id);
    setForm({ title: item.title, content: item.content, priority: item.priority, publish_date: item.publish_date, expire_date: item.expire_date || "", send_push: false });
    setError("");
    setShowForm(true);
  };

  const handleSave = async () => {
    setError("");
    if (!form.title || !form.content || !form.publish_date) { setError("Baslik, icerik ve yayin tarihi zorunludur"); return; }
    const data = { ...form, expire_date: form.expire_date || null };
    try {
      if (editId) {
        await api.updateDuyuru(editId, data);
        setMsg("Duyuru guncellendi!");
      } else {
        await api.createDuyuru(data);
        setMsg("Duyuru yayinlandi!");
      }
      setShowForm(false);
      load();
      setTimeout(() => setMsg(""), 3000);
    } catch (e: any) { setError(e.message); }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Bu duyuruyu silmek istediginize emin misiniz?")) return;
    await api.deleteDuyuru(id);
    load();
  };

  return (
    <div>
      {msg && <div className="mb-4 rounded-xl bg-green-50 p-3 text-sm text-green-700">{msg}</div>}

      <div className="mt-3 flex items-center justify-between">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">Duyurular ({items.length})</h4>
        <button onClick={openCreate} className="flex items-center gap-2 rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-600 transition">
          <MdAdd className="h-5 w-5" /> Yeni Duyuru
        </button>
      </div>

      <Card extra="mt-4 p-4">
        {loading ? (
          <p className="p-4 text-center text-gray-500">Yukleniyor...</p>
        ) : items.length === 0 ? (
          <p className="p-4 text-center text-gray-500">Henuz duyuru yok</p>
        ) : (
          <div className="space-y-3">
            {items.map((item) => (
              <div key={item.id} className="flex items-start justify-between rounded-xl border border-gray-100 p-4 hover:bg-gray-50 dark:border-navy-700 dark:hover:bg-navy-700/50 transition">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${PRIORITY_STYLES[item.priority]}`}>
                      {PRIORITY_ICONS[item.priority]} {PRIORITY_LABELS[item.priority]}
                    </span>
                    {!item.is_active && <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">Pasif</span>}
                  </div>
                  <h5 className="font-bold text-navy-700 dark:text-white">{item.title}</h5>
                  <p className="text-sm text-gray-600 mt-1">{item.content}</p>
                  <div className="flex gap-4 mt-2 text-xs text-gray-400">
                    <span>Yayin: {new Date(item.publish_date).toLocaleDateString("tr-TR")}</span>
                    {item.expire_date && <span>Bitis: {new Date(item.expire_date).toLocaleDateString("tr-TR")}</span>}
                  </div>
                </div>
                <div className="flex gap-2 ml-4">
                  <button onClick={() => openEdit(item)} className="text-brand-500 hover:text-brand-700"><MdEdit className="h-5 w-5" /></button>
                  <button onClick={() => handleDelete(item.id)} className="text-red-400 hover:text-red-600"><MdDelete className="h-5 w-5" /></button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>

      {/* Form Modal */}
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setShowForm(false)}>
          <div className="w-full max-w-md rounded-2xl bg-white p-6 dark:bg-navy-800" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold text-navy-700 dark:text-white mb-4">{editId ? "Duyuru Duzenle" : "Yeni Duyuru"}</h3>
            {error && <div className="mb-4 rounded-xl bg-red-50 p-3 text-sm text-red-600">{error}</div>}
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Baslik *</label>
                <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
                  placeholder="Duyuru basligi" className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Icerik *</label>
                <textarea value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })}
                  placeholder="Duyuru icerigi" rows={4} className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Oncelik</label>
                <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}
                  className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white">
                  <option value="normal">Normal</option>
                  <option value="important">Onemli</option>
                  <option value="urgent">Acil</option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Yayin Tarihi *</label>
                  <input type="date" value={form.publish_date} onChange={(e) => setForm({ ...form, publish_date: e.target.value })}
                    className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Bitis Tarihi</label>
                  <input type="date" value={form.expire_date} onChange={(e) => setForm({ ...form, expire_date: e.target.value })}
                    className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
                </div>
              </div>
              <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-gray-200 p-3 dark:border-navy-600">
                <input type="checkbox" checked={form.send_push} onChange={(e) => setForm({ ...form, send_push: e.target.checked })}
                  className="mt-0.5 h-4 w-4 accent-brand-500" />
                <span>
                  <span className="flex items-center gap-1 text-sm font-medium text-navy-700 dark:text-white">
                    <MdNotifications className="h-4 w-4" /> {editId ? "Bu guncelleme icin tekrar push bildirimi gonder" : "Mobil push bildirimi gonder"}
                  </span>
                  <span className="text-xs text-gray-400">
                    {editId ? "Isaretlersen bu duzenleme sonrasi tum kullanicilara yeniden bildirim duser." : "Duyuru yayinlaninca tum kullanicilarin telefonuna aninda bildirim duser."}
                  </span>
                </span>
              </label>
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <button onClick={() => setShowForm(false)} className="rounded-xl px-5 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-100">Iptal</button>
              <button onClick={handleSave} className="rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-600">{editId ? "Guncelle" : "Yayinla"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Duyurular;
